'use strict';

module.exports = 'data-reactid';


//////////////////
// WEBPACK FOOTER
// ./~/react-three-renderer/lib/utils/idPropertyName.js
// module id = 261
// module chunks = 1